import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Toast {
	content: string;
	buttontext: string;
	classname?: string;
	duration?: number;
}


@Injectable({ providedIn: 'root' })
export class ToastService {

	constructor(
		private _translateService: TranslateService
	) { }

	toasts: Toast[] = [];

	open(content: string, closebutton: string = null, format: {panelClass:string, duration: number}): number {
		let c = format.panelClass;

		switch (c) {
			case 'mat-success':
			case 'success':
				c = 'bg-e-light-green'//'bg-e-white border border-solid border-e-dark-green'
				break;
			case 'mat-warn':
			case 'warn':
				c = 'bg-e-orange text-white'
		}


		const toast: Toast = {
			content: content,
			buttontext: closebutton, 
			duration: format.duration,
			classname: c? c:  'bg-e-light-green' // 'bg-e-white border border-solid border-e-dark-green',
		}

		return this.toasts.push(toast);
	}

	openWithTranslate(content: string, closebutton:string = null, format: {panelClass:string, duration: number}){
		let arr = [content]
		if(closebutton)
			arr.push(closebutton)

		this._translateService.get(arr).subscribe(res=>{
			this.open(res[content], closebutton? res[closebutton]: null, format);
		})
	}


	remove(index: number) {
		// this.toasts = this.toasts.filter((t, i) => i !== index);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}
}
